import React from 'react';
import PropTypes from 'prop-types';

import MembershipSettingPresenter from '../../../../../presenters/MembershipSettingPresenter';

const MembershipSetting = (props) => {
  const { membershipSetting, onEditMembershipSetting } = props;

  const handleClick = () => onEditMembershipSetting(membershipSetting);

  return (
    <React.Fragment>
      <tr>
        <td>
          {MembershipSettingPresenter.settingTypeReadable(membershipSetting)}
        </td>
        <td>{MembershipSettingPresenter.description(membershipSetting)}</td>
        <td>{MembershipSettingPresenter.value(membershipSetting)}</td>
        <td>
          <div>
            <button className="action-button" onClick={handleClick}>
              Change
            </button>
          </div>
        </td>
      </tr>
    </React.Fragment>
  );
};

MembershipSetting.propTypes = {
  membershipSetting: MembershipSettingPresenter.shape().isRequired,
  onEditMembershipSetting: PropTypes.func.isRequired,
};

export default MembershipSetting;
